/*
 * @Author: Suroc
 * @Date: 2024-01-25 18:10:01
 * @LastEditTime: 2024-09-24 10:03:33
 * @Description: Main
 */
import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import pinia from '@/stores/index'
import 'animate.css'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/theme-chalk/index.css'
import 'element-plus/dist/index.css';
import zhCN from 'element-plus/es/locale/lang/zh-cn' // 引入中文语言包
import './styles/index.less'
import suroc from './suroc'
import i18n from './i18n'
import 'vant/lib/index.css';
// 将jQuery设置为全局变量
import $ from 'jquery'
window.$ = $
window.jQuery = $

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(pinia)
app.use(router)
app.use(ElementPlus, { locale: zhCN })
app.use(suroc)
app.use(i18n)// 使用 i18n
app.mount('#app')
